import type { Note } from "@studygenie/db";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useDeleteNote = ({ id }: { id: string }) => {
  const router = useRouter();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  const t = useI18n();
  return useMutation(
    trpc.notes.delete.mutationOptions({
      onSuccess: async () => {
        queryClient.setQueriesData<Note[]>(
          {
            queryKey: trpc.notes.getNotes.queryKey(),
          },
          (existingData) => {
            if (existingData) {
              return existingData.filter((note) => note.id !== id);
            }
            return existingData;
          },
        );
        if (pathname.includes(id)) {
          router.push("/my-studysets?tab=notes");
        }
        toast.success(t("noteView.api.noteDeleted"));
      },
      onError: (error) => {
        console.error("Failed to delete note", error);
        queryClient.invalidateQueries({
          queryKey: trpc.notes.getNotes.queryKey(),
        });
        toast.error(error.message);
      },
    }),
  );
};
